import { z } from 'zod';
import { FlowDurationSchema } from '../../../duration/duration.js';
import { BaseFlowBlockSchema } from '../block.js';
import { FlowBlockType } from '../type.js';
export const FlowWaitForSignalBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.WaitForSignal),
    config: z.object({
        signalName: z.string(),
        timeout: FlowDurationSchema,
    }),
});
//# sourceMappingURL=config.js.map